import LORFacetItem from '@/routers/views/setup/lor-facets/lor-facets-item';
import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import CustomMetadataPanel from './custom-metadata-panel/custom-metadata-panel.vue';

@Component({
     name: 'lor-facets-metadata-card',
     components: {
        'custom-component': CustomMetadataPanel,
     },
})
export default class LORFacetsMetadataCard extends Vue {

    // -----------------------------------------------------------
    // Properties

    @Prop()
    public facetItem: any;

    @Prop()
    public modalRef: any;

    @Prop()
    public isFacetEdit!: boolean;

    @Prop()
    public facetKeysList: any;

    public isSubmitted: boolean = false;

    public customFilterKeyRules: any = {
        required: true,
    };

    public facetsMetadata: any = new LORFacetItem('',
        {
            search: '', cap: '', labelKey: '',
            valueKey: '', hasMultiSelect: false, facetKey: '',
            isCustom: false, endpointUrl: null, useLookup: false,
        },
    );

    @Provide('validator') public $validator: any = this.$validator;

    // -----------------------------------------------------------
    // Action

    public onAddFacetMetadata() {
        this.isSubmitted = true;
        this.$validator.validate().then((valid: any) => {
            if (valid) {
                this.$emit('onCreateFacet', this.createFacetObject());
                this.onClose();
                this.isSubmitted = false;
            }
        });

    }

    public onDeleteMetadata() {
        const { filterKey } = this.facetItem;
        this.$emit('onDeleteMetadata', filterKey.facetKey);
    }

    public onClose() {
        this.modalRef.hide();
    }

    // -----------------------------------------------------------
    // Hooks

    private created() {
        const facetKeysList = this.facetKeysList;
        if (this.isFacetEdit) {
            this.facetsMetadata = this.facetItem;
        } else {
            // Helps to avoid creating existing keys
            this.customFilterKeyRules.excluded = facetKeysList;
        }
    }

    // -----------------------------------------------------------
    // Methods

    private createFacetObject() {
        const facetsMetadata = this.facetsMetadata;
        return {
            [facetsMetadata.filterKey.facetKey] : facetsMetadata,
        };
    }


}
